import { Box, Button, Divider, Grid, Typography } from "@mui/material";
import { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSummaryGraph, summarySelector, getSummaryPdf } from '../../store/slices/summarySlice';
import { percentFormatOneDigit } from '../../helpers/formatter';
import DropdownDatepicker from './DropdownDatepicker';
import Chart from './Chart';
import DropdownButton from "./DropdownButton";


export default function Summary() {

	const dispatch = useDispatch();
	const { groups, categories, total, loading } = useSelector(summarySelector);
	const [groupList, setGroupList] = useState([])
	const [categoryList, setCategoryList] = useState([])
	const [totalObj, setTotalObj] = useState(null)
	const [chartLabel, setChartLabel] = useState('Global Unidad de Negocio')

	const [normativo, setNormativo] = useState(null)
	const [interno, setInterno] = useState(null)

	const [showGroups, setShowGroups] = useState(true)
	const [showCategories, setShowCategories] = useState(true)

	const [buttonFocus, setButtonFocus] = useState({
		all: true,
		group: false,
		category: false
	})

	const [btnPeriodFocus, setPeriodBtnFocus] = useState(true)

	useEffect(() => {
		dispatch(getSummaryGraph());
	}, [dispatch])

	useEffect(() => {
		if (total) {
			setTotalObj(total)
			setNormativo(total?.scope?.normativo)
			setInterno(total?.scope?.interno)
			setGroupList(groups)
			setCategoryList(categories)
			setChartLabel('Global Unidad de Negocio')
			setButtonFocus({
				all: true,
				group: false,
				category: false
			})
		}
	}, [groups, categories, total])

	const getPdf = () => {
		dispatch(getSummaryPdf())
	}

	const getChart = (obj) => {

		if (!obj) {
			return <Chart data={{
				labels: ['25', '25', '50'],
				data: [25, 25, 50]
			}} />

		} else {

			const cumple = obj.aprobada;
			const cumpleFueraPlazo = obj.fueraPlazo;
			const noCumple = obj.pendiente + obj.noFinalizada;

			const cumpleLbl = cumple !== 0 ? `${percentFormatOneDigit(cumple * 100 / obj.total)}` : '';
			const cumpleFueraPlazoLbl = cumpleFueraPlazo !== 0 ? `${percentFormatOneDigit(cumpleFueraPlazo * 100 / obj.total)}` : '';
			const noCumpleLbl = noCumple !== 0 ? `${percentFormatOneDigit(noCumple * 100 / obj.total)}` : '';

			const data = {
				labels: [
					cumpleLbl,
					cumpleFueraPlazoLbl,
					noCumpleLbl
				],
				data: [
					cumple,
					cumpleFueraPlazo,
					noCumple
				]
			}

			return <Chart data={data} />

		}
	}

	const getChartBox = (x, i) => <Grid container key={i}
		direction={"column"}
		justifyContent={"center"}
		alignSelf={"start"}
		alignItems={"center"}
		width={'10%'}
		margin={2}
	>
		<Typography fontWeight={600}>{x.name}</Typography>
		<Typography variant="caption">{`${x.total} Tareas`}</Typography>
		{getChart(x)}
	</Grid>

	const handleAll = () => {
		setTotalObj(total)
		setNormativo(total?.scope?.normativo)
		setInterno(total?.scope?.interno)
		setGroupList(groups)
		setCategoryList(categories)
		setChartLabel('Global Unidad de Negocio')
		setButtonFocus({
			all: true,
			group: false,
			category: false
		})
		setShowGroups(true)
		setShowCategories(true)
	}

	const handleGroup = (group) => {
		const [selected] = groups.filter(x => x.name === group)
		const [_normativo] = selected.scope.filter(x => x.name === 'Normativo')
		const [_interno] = selected.scope.filter(x => x.name === 'Interno')
		setTotalObj(selected)
		setNormativo(_normativo)
		setInterno(_interno)
		setCategoryList(selected.list)
		// setGroupList([])	
		setShowGroups(false)
		setShowCategories(true)	
		setChartLabel(`Grupo: ${group}`)
		setButtonFocus({
			all: false,
			group: true,
			category: false
		})
	}

	const handleCategory = (category) => {
		const [selected] = categories.filter(x => x.name === category)
		const [_normativo] = selected.scope.filter(x => x.name === 'Normativo')
		const [_interno] = selected.scope.filter(x => x.name === 'Interno')
		setTotalObj(selected)
		setNormativo(_normativo)
		setInterno(_interno)
		setGroupList(selected.list)
		// setCategoryList([])
		setShowGroups(true)
		setShowCategories(false)
		setChartLabel(`Categoría: ${category}`)
		setButtonFocus({
			all: false,
			group: false,
			category: true
		})
	}

	const coloredSquare = color => <div style={{
		width: '20px',
		height: '15px',
		backgroundColor: color,
		margin: '0px 5px 0px 20px'
		}}>
	</div>

	return (
		<>
			<Box sx={{ display: 'flex', justifyContent: 'center' }}>
				<h3>Reporte de Cumplimiento GRC</h3>
			</Box>

			{loading ?
				<div>Cargando infomación , espere un momento!</div>
				:

				<Fragment>
					{/* Sección Controles */}
					<Grid container justifyContent={"space-between"} alignItems={"center"}>

						<Grid item sm={4} mb={1}>
							<DropdownDatepicker btnFocus={btnPeriodFocus} setBtnFocus={setPeriodBtnFocus}/>
						</Grid>

						<Grid item sm={4} mb={1}>
							<Grid container justifyContent={"center"}>
								<Grid container justifyContent={"space-between"} alignItems={"center"}
									width={'225px'}
									sx={{
										background: 'rgb(73, 97, 117)',
										padding: 0.5,
										borderRadius: 1
									}}
								>
									<Button
										onClick={handleAll}
										sx={{
											bgcolor: buttonFocus.all ? '#bdbdbd' : 'rgb(73, 97, 117)',
											color: '#fff',
											height: '25px',
											fontSize: '10px'
										}}>
										Global
									</Button>

									<DropdownButton
										label={'Grupo'}
										data={groupList}
										handleSelect={handleGroup}
										bgcolor={buttonFocus.group ? '#bdbdbd' : 'rgb(73, 97, 117)'}
									/>

									<DropdownButton
										label={'Categoria'}
										data={categoryList}
										handleSelect={handleCategory}
										bgcolor={buttonFocus.category ? '#bdbdbd' : 'rgb(73, 97, 117)'}
									/>

								</Grid>
							</Grid>
						</Grid>

						<Grid item sm={4} mb={1}>
							<Grid container justifyContent={"flex-end"}>
								<Button variant="contained" size="large"
									onClick={getPdf}
									sx={{
										bgcolor: '#19857b',
										color: '#fff',
										height: '33px',
										fontSize: '10px',
										mr: 1
									}}>
									Generar PDF
								</Button>
							</Grid>
						</Grid>


					</Grid>

					<Divider />

					{/* Sección graficos */}

					<Grid container justifyContent={"space-between"} mt={6} spacing={1}>
						<Grid width={'40%'}>
							<Typography fontWeight={600}>
								{chartLabel}
							</Typography>
							<Typography variant="caption">{`${totalObj?.total} Tareas`}</Typography>
						</Grid>

						<Grid width={'20%'}>
							{getChart(totalObj)}
						</Grid>

						{/* Separador vertical */}
						<Grid width={'15%'}></Grid>

						<Grid container direction={"column"} justifyContent={"center"} alignSelf={"start"} alignItems={"center"} width={'10%'} mr={1}>
							{(normativo && normativo?.total !== 0) &&
								<Fragment>
									<Typography fontWeight={600}>Normativo</Typography>
									<Typography variant="caption">{`${normativo?.total} Tareas`}</Typography>
									{getChart(normativo)}
								</Fragment>
							}
						</Grid>

						<Grid container direction={"column"} justifyContent={"center"} alignSelf={"start"} alignItems={"center"} width={'10%'}>
							{(interno && interno?.total !== 0) &&
								<Fragment>
									<Typography fontWeight={600}>Interno</Typography>
									<Typography variant="caption">{`${interno?.total} Tareas`}</Typography>
									{getChart(interno)}
								</Fragment>
							}
						</Grid>


					</Grid>

					{/* Leyenda */}
					<Grid container justifyContent={"center"} alignItems={"center"} mt={2}>
						{coloredSquare('rgb(54, 185, 21)')}
						<Typography variant="caption">Cumple</Typography>
						{coloredSquare('yellow')}
						<Typography variant="caption">Cumple Fuera de Plazo</Typography>
						{coloredSquare('red')}
						<Typography variant="caption">No Cumple</Typography>
					</Grid>

					{(groupList.length > 0 && showGroups)&&
						<Fragment>
							<h3>Cumplimiento de Grupos</h3>

							<Divider />
							<Grid container>
								{groupList.map((x, i) =>
									getChartBox(x, i)
								)}
							</Grid>
						</Fragment>
					}

					{(categoryList.length > 0 && showCategories) &&
						<Fragment>
							<h3>Cumplimiento de Categorías</h3>

							<Divider />
							<Grid container>
								{categoryList.map((x, i) =>
									getChartBox(x, i)
								)}
							</Grid>
						</Fragment>
					}

				</Fragment>

			}

		</>
	)
}